import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useLanguage } from '../../../contexts/LanguageContext';

/**
 * NSherjFh PR 9 — induction soft-delete confirm modal. Mirrors
 * PRs 2-8 modals with the template/acknowledgement split nuance
 * (PR 3 rams + PR 8 checklists precedent): existing completions
 * REMAIN visible in historical/audit reads after soft-delete —
 * a worker's signed off completion is a fact regardless of
 * whether the parent is later deleted.
 */
const InductionDeleteConfirmModal = ({ isOpen, onClose, onConfirm, inductionTitle }) => {
  const { t } = useLanguage();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-modal flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="bg-card rounded-lg shadow-elevation-5 w-full max-w-md">
        <div className="p-6">
          <div className="flex items-start gap-4 mb-4">
            <div className="flex items-center justify-center w-12 h-12 bg-destructive/10 rounded-full flex-shrink-0">
              <Icon name="AlertTriangle" size={24} color="var(--color-destructive)" />
            </div>
            <div className="flex-1">
              <h2 className="text-lg font-semibold text-foreground mb-2">
                Delete induction?
              </h2>
              <p className="text-sm text-muted-foreground">
                Remove "{inductionTitle}" from active views. You can restore it from the Deleted tab.
              </p>
            </div>
          </div>

          <div className="bg-warning/10 border border-warning/20 rounded-lg p-4 mb-6">
            <div className="flex items-start gap-3">
              <Icon name="AlertCircle" size={20} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-foreground mb-1">Workers + completion history</p>
                <p className="text-sm text-muted-foreground">
                  Workers no longer see this in their acknowledgement queue. Existing completions remain in the audit history — who signed off and when is preserved. The induction file stays in storage. Restoring brings everything back active.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 p-4 border-t border-border bg-muted/30">
          <Button variant="outline" onClick={onClose}>
            {t('cancel')}
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            iconName="Trash2"
            iconPosition="left"
          >
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InductionDeleteConfirmModal;
